export default {
  title: {
    list: "設置会社一覧",
    create: "設置会社一覧/作成",
    edit: "設置会社一覧/編集",
  },
  csv: {
    import: "設置会社の入力"
  },
  id: "ID",
  companyName: "社名",
  contactName: "担当者名",
  managementOffice: "管理会社",
  comment: "コメント",
  status: "ステータス",
  personInCharge: "管理会社担当者",
  updatedAt: "最終更新日",
  updatedBy: "最終更新者",
  installationOffice: "設置会社",
  installationOfficeName: "設置会社名",
  list: {
    edit: "編集",
    existComment: "有",
    notExistComment: "無し",
  },
  form: {
    companyNameJapan: "社名(カナ)",
    email: "メール",
    operationOffice: "運営会社",
    list: "一覧",
    selected: "選択済",
    operationOfficeName: "運営会社名",
    expiryDate: "有効期限",
  }
}
